<template>
  <div>
    <booking-infor
      :booking-info="bookingInfo"
    ></booking-infor>
    <p class="mt-3">
      {{ transferBookingText }}
    </p>
    <user-list
      ref="selectCoachList"
      :enable-search="true"
      :user-list="coachList"
    ></user-list>
  </div>
</template>
<script setup>
import { ref, onMounted, toRefs, watch } from 'vue'
import BookingInfor from './BookingInfo'
import UserList from '@/components/UserSelector/UserList'
import { listAvailableCoach } from '@/api/bookedCourse'

import { useStore } from '@/store'

const transferBookingText = 'Please assign the new coach for the booking'

const selectCoachList = ref(null)
const coachList = ref([])

const props = defineProps({
  bookingInfo: {
    type: Object,
    default() {
      return {
        id: -1,
        bookingNo: 'BAM2200001',
        studentName: 'Paul Chan',
        location: 'Mong Kok',
        date: '2022-06-13',
        time: '15:00 ~ 16:00',
      }
    },
  },
})
const { bookingInfo } = toRefs(props)

// const store = useStore()

// watch(bookingInfo, newValue => {
//   console.log('new booking info:', newValue)
//   listAvailableCoach({
//     id: bookingInfo.value.id,
//   }).then(response => {
//     console.log('listCoach result', response.data.items)
//     coachList.value = [...response.data.items]
//   })
//     .catch(err => {
//       console.log('err', err)
//     })
// })

onMounted(() => {
  console.log('bookingInfo', bookingInfo)

  listAvailableCoach({
    id: bookingInfo.value.id,
  }).then(response => {
    console.log('listCoach result', response.data.items)
    coachList.value = [...response.data.items]
  })
    .catch(err => {
      console.log('err', err)
    })
})
function reset() {
  selectCoachList.value.internalList = [...coachList.value]
  selectCoachList.value.selectedList = []
}

function getTransferData() {
  let assignedCoachID = -1
  if (selectCoachList.value.selectedList && selectCoachList.value.selectedList.length > 0) {
    assignedCoachID = selectCoachList.value.selectedList[0].id
  }

  return {
    bookedCourseID: bookingInfo.value.id,
    assignedCoachID,
  }
}
defineExpose({ getTransferData, reset })
</script>
